module.exports = __webpack_public_path__ + "static/02-dove-zoom-78d83deb7066feda05e8cdf72d3bdbf0.jpg";